var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 4.89719V4.375C16.75 2.02375 13.2034 0.25 8.5 0.25C3.79656 0.25 0.25 2.02375 0.25 4.375V8.125C0.25 10.0834 2.71094 11.6397 6.25 12.1056V12.625C6.25 14.9762 9.79656 16.75 14.5 16.75C19.2034 16.75 22.75 14.9762 22.75 12.625V8.875C22.75 6.93437 20.3669 5.37625 16.75 4.89719ZM21.25 8.875C21.25 10.1144 18.3634 11.5 14.5 11.5C14.1503 11.5 13.8034 11.4878 13.4613 11.4653C15.4834 10.7284 16.75 9.53125 16.75 8.125V6.41313C19.5503 6.83031 21.25 7.96281 21.25 8.875ZM6.25 10.5859V8.35563C6.99604 8.45283 7.74765 8.50106 8.5 8.5C9.25235 8.50106 10.004 8.45283 10.75 8.35563V10.5859C10.0051 10.696 9.25302 10.7508 8.5 10.75C7.74698 10.7508 6.99493 10.696 6.25 10.5859ZM15.25 6.80594V8.125C15.25 8.91156 14.0866 9.75625 12.25 10.2691V8.07812C13.4603 7.78469 14.485 7.34781 15.25 6.80594ZM8.5 1.75C12.3634 1.75 15.25 3.13562 15.25 4.375C15.25 5.61438 12.3634 7 8.5 7C4.63656 7 1.75 5.61438 1.75 4.375C1.75 3.13562 4.63656 1.75 8.5 1.75ZM1.75 8.125V6.80594C2.515 7.34781 3.53969 7.78469 4.75 8.07812V10.2691C2.91344 9.75625 1.75 8.91156 1.75 8.125ZM7.75 12.625V12.2341C7.99656 12.2434 8.24594 12.25 8.5 12.25C8.86375 12.25 9.21906 12.2378 9.56781 12.2172C9.95524 12.3559 10.3499 12.4736 10.75 12.5697V14.7691C8.91344 14.2562 7.75 13.4116 7.75 12.625ZM12.25 15.0859V12.85C12.9958 12.9503 13.7475 13.0004 14.5 13C15.2523 13.0011 16.004 12.9528 16.75 12.8556V15.0859C15.258 15.3047 13.742 15.3047 12.25 15.0859ZM18.25 14.7691V12.5781C19.4603 12.2847 20.485 11.8478 21.25 11.3059V12.625C21.25 13.4116 20.0866 14.2562 18.25 14.7691Z",
    fill: "url(#paint0_linear_5763_4602)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5763_4602",
    x1: 0.25,
    y1: 16.75,
    x2: 15.8809,
    y2: 9.60814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF375F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/Coins.b6570b95500aa8f154fe6be48637fb18.svg";
export { ForwardRef as ReactComponent };